import { cn } from "@/lib/utils";

/**
 * Product lockup: the purple hand icon + a live "UnfoldWin" wordmark. The wordmark
 * is set in Lato on purpose (a brand exception); the rest of the UI stays Manrope.
 * Sized to replace the old h-8 combined PNG one-for-one. The two purples are
 * the exact tones from that artwork ("Unfold" deep, "Win" matching the icon).
 */
export function BrandLockup({ className }: { className?: string }) {
  return (
    <span className={cn("inline-flex shrink-0 items-center gap-[7px]", className)}>
      <img src="/images/UnfoldWin - dark.png" alt="" className="h-8 w-8" />
      <span className="whitespace-nowrap font-wordmark text-[18px] font-normal leading-none tracking-[0.02em]">
        <span className="text-[#413362]">Unfold</span>
        <span className="text-[#604B8E]">Win</span>
      </span>
    </span>
  );
}
